<template>
  <div class="grid-view">
    <div
      v-show="showMainList"
      class="main-content"
    >
      <search-item
        config-module="231403"
        :reset="true"
        no="1"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
      >
        <cargo-advance-select
          slot="customCompany"
          slot-scope="{ item, getValueFromChild }"
          :select-type="TYPE_NAMES.basic_data_Company"
          :clear-not-match="true"
          filterable
          :callback-params="{ refCode: item.itemName, fieldType: item.fieldType }"
          :default-multiple-value="item.itemValue instanceof Array ? item.itemValue : []"
          :multiple="true"
          :tag-value="item.tagValue !== '' ? item.tagValue : item.subType.tagValue"
          options-width="300px"
          :headers="item.headers || []"
          :fields="item.fields || []"
          :tag-name="item.tagName"
          placeholder=" "
          :static-options="overCreditAccounts"
          @parentCallBack="data=>getValueFromChild(data)"
        />
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="23140300"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          no="2"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="23140300"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
          no="3"
          @pagination="toQuery"
        />
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import {
  queryCreditLogList,
  queryLogOverCreditAccountIds
} from '@/api/sales/creditBusinessManage'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import RouterAndPrintRenderer from '@/components/Cargo/Common/routerAndPrintRenderer'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getFilterCacheList } from '@/utils/basicDataCache'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'TabCreditLog',
  components: {
    searchItem, cargoAdvanceSelect
  },
  data() {
    return {
      URL,
      TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      rowData: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {},
      showDetail: false,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          RouterAndPrintRenderer
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_OperationType'), field: 'creditControlAction', colId: 'creditControlAction', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.creditHistoryActionFun(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_OperateTime'), field: 'creditControlTime', colId: 'creditControlTime', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('Payment.operator'), field: 'creditControlUser', colId: 'creditControlUser', width: 200,
          cellRenderer: (params) => {
            const username = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            return username === '' ? this.$t('Sales.System') : username
          } },
        {
          headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', colId: 'jobJobNo', width: 200
        }, { headerName: this.$t('Payment.warehouseNo'), field: 'jobWarehouseNo', colId: 'jobWarehouseNo', width: 200 },
        { headerName: this.$t('Payment.bookingNo'), field: 'jobBookingNo', colId: 'jobBookingNo', width: 200 },
        { headerName: this.$t('Payment.SONO'), field: 'jobSoNo', colId: 'jobSoNo', width: 200 },
        { headerName: this.$t('Payment.itemNo'), field: 'jobPoNo', colId: 'jobPoNo', width: 200 },
        {
          headerName: this.$t('SeaExport.DateOfArrival'), field: 'jobEta', colId: 'jobEta', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.DateOfDeparture'), field: 'jobEtd', colId: 'jobEtd', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.mbl'), field: 'jobMbl', colId: 'jobMbl', width: 200 },
        { headerName: this.$t('Payment.separateNumber'), field: 'jobHbl', colId: 'creditControlUser', width: 200 },
        {
          headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'jobOverseaOp', colId: 'jobOverseaOp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', colId: 'jobCustomerId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.NominatedAgent'), field: 'jobDesignationAgent', colId: 'jobDesignationAgent', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.solicitationType'), field: 'jobCargoSource', colId: 'jobCargoSource', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Payment.carrier'), field: 'jobCarrierId', colId: 'jobCarrierId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.businessType'), field: 'jobLob', colId: 'jobLob', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', colId: 'jobBusinessDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.customJobType'), field: 'jobCustomJobType', colId: 'jobCustomJobType', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'name')
          }
        },
        { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVessel', colId: 'jobVessel', width: 200 },
        {
          headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', colId: 'jobLoadingPortCode', width: 200,
          cellRenderer: (params) => {
            if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('Payment.portOfDestination'), field: 'jobDestinationPortCode', colId: 'jobDestinationPortCode', width: 200,
          cellRenderer: (params) => {
            if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('SeaExport.departureStation'), field: 'jobDepartureStation', colId: 'jobDepartureStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.destinationStation'), field: 'jobDestinationStation', colId: 'jobDestinationStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.transitStation'), field: 'jobTransitStation', colId: 'jobTransitStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('Payment.destinationAgent'), field: 'jobDestinationAgent', colId: 'jobDestinationAgent', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.operation'), field: 'jobOp', colId: 'jobOp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.sales'), field: 'jobSales', colId: 'jobSales', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.customerService'), field: 'jobCsr', colId: 'jobCsr', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.Documents'), field: 'jobDc', colId: 'jobDc', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Payment.businessReferenceNumber'), field: 'jobCustomerRefNo', colId: 'jobCustomerRefNo', width: 200 },
        { headerName: this.$t('Payment.relatedJob'), field: 'jobRelatedJob', colId: 'jobRelatedJob', width: 200 },
        { headerName: this.$t('Payment.trustFromJob'), field: 'jobTrustFromJob', colId: 'jobTrustFromJob', width: 200 },
        {
          headerName: this.$t('Payment.planner'), field: 'jobPlanner', colId: 'jobPlanner', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.accrued'), field: 'jobProvisioned', colId: 'jobProvisioned', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Payment.businessStatus'), field: 'jobJobState', colId: 'jobJobState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobStateLabelFunc(params.value)
          },
          hide: true
        },
        { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', colId: 'jobUserDefinedField1', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', colId: 'jobUserDefinedField2', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', colId: 'jobUserDefinedField3', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'jobUserDefinedField4', colId: 'jobUserDefinedField4', width: 200, hide: true },
        {
          headerName: this.$t('Invoice.invoice_salesDepartment'), field: 'jobSalesDepartment', colId: 'jobSalesDepartment', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('Sales.OverControllAccountReceivable'),
          field: 'overCreditAccountIds',
          width: 200,
          valueFormatter: params => {
            if (params.value) {
              const vals = params.value.split(',')
              const txts = []
              for (const val of vals) {
                txts.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(val), 'chineseName'))
              }
              return (vals.length > 1 ? `【${vals.length}${this.$t('Sales.Family')}】` : '') + txts.join(',')
            }
            return ''
          },
          hide: true
        }
      ],
      overCreditAccounts: []
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.loadOverCreditAccounts()
      this.toQuery()
    }
  },
  mounted() {
    this.loadOverCreditAccounts()
    this.toQuery()
  },
  methods: {
    loadOverCreditAccounts() {
      const loading = getLoading4Cxt(this)
      queryLogOverCreditAccountIds({ branchId: this.$store.getters.currentOfficeId }).then(res => {
        loading.close()
        this.overCreditAccounts = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => res.data.includes(p.cmpIdx))
      }).catch(() => {
        loading.close()
      })
    },
    fetchOrderRequirement() {
      this.fullscreenLoading = getLoading()
      queryCreditLogList(this.filter)
        .then((res) => {
          this.filter.total = Number(res.data.total)
          this.rowData = res.data.list
          this.fullscreenLoading.close()
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryCreditLogList(this.filter).then((res) => this.handleQueryData(res)).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      console.log('----toAdvancedQuery----')
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = this.handleConditionsBeforeQuery(data)
        this.filter.pageNum = 1
      }
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryCreditLogList(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    // 在查询之前，对条件进行预处理
    handleConditionsBeforeQuery(data) {
      if (AdvancedSearchOption.hasField('charge.ACCOUNT_ID', data)) {
        const condition = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', true)
        data.push(condition.formatObj2Json())
      }
      return data
    }
  }
}
</script>
